import "../scss/style.scss";

console.log(1);
